import React from "react";
import css from './loginFormPanel.module.scss'
import {observer} from "mobx-react";
import LoginForm from 'components/login-form/LoginForm'

const Index = () => {
    return (
        <div className={css.root}>
            <LoginForm className={css.loginForm}/>
        </div>
    )
}

export default observer(Index)